import {
  ButtonArrowState,
  ErrorAlert,
  InfoAlert,
  Loader,
  Modal,
  TertiaryButton,
} from '@huggg/react-components';
import MastercardIcon from 'assets/img/prepaid-cards/mastercard.svg';
import dictionary from 'config/dictionary';
import { format, parseISO } from 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import { interpolate } from 'utilities/interpolate';
import CopyableDetail from './CopyableDetail';
import ImageDetail from './ImageDetail';
import styles from './prepaidCard.module.scss';

const CardDetailsModal = ({
  title,
  cardExpiryDate,
  sensitiveCardData,
  isLoading,
  error,
  onClose,
}) => {
  const formattedCardNumber =
    sensitiveCardData && sensitiveCardData.cardNumber.replace(/(.{4})/g, '$1 ');
  const formattedExpiryDate =
    sensitiveCardData &&
    sensitiveCardData.expiryDate.replace(/\d\d(\d{2})-(\d{2}).*/, '$2 / $1');
  const expiryDeadline =
    cardExpiryDate &&
    interpolate(
      dictionary.prepaidCardExpiry,
      '[expiry_date]',
      <>{format(parseISO(cardExpiryDate), 'do MMM yyyy')}</>,
    );

  return (
    <Modal
      title={title.toUpperCase()}
      onClose={onClose}
      className={styles.cardDetailsModal}
    >
      {isLoading && <Loader />}
      {error && (
        <div className={styles.cardDetailsErrorContainer}>
          <ErrorAlert
            message={dictionary.prepaidCards.errors.retrievingCardDetails}
          />
        </div>
      )}
      {!isLoading && !error && sensitiveCardData && (
        <>
          <div className={styles.cardDetailsModalContent}>
            <ImageDetail
              label={dictionary.prepaidCards.labels.cardType}
              detail={'Mastercard®'}
              image={<img src={MastercardIcon} alt="Mastercard Logo" />}
            />
            <CopyableDetail
              label={dictionary.prepaidCards.labels.nameOnCard}
              detail={sensitiveCardData.fullName}
            />
            <CopyableDetail
              label={dictionary.prepaidCards.labels.cardNumber}
              detail={formattedCardNumber}
            />
            <div>
              <CopyableDetail
                label={dictionary.prepaidCards.labels.expiryDate}
                detail={formattedExpiryDate}
              />
              {expiryDeadline && (
                <div style={{ marginTop: '12px' }}>
                  <InfoAlert message={expiryDeadline} />
                </div>
              )}
            </div>
            <CopyableDetail
              label={dictionary.prepaidCards.labels.cvv}
              detail={sensitiveCardData.cvv}
            />
            <TertiaryButton
              label={dictionary.prepaidCards.labels.closeThisWindow}
              onClick={onClose}
              arrow={ButtonArrowState.None}
            />
          </div>
        </>
      )}
    </Modal>
  );
};

CardDetailsModal.propTypes = {
  title: PropTypes.string.isRequired,
  cardExpiryDate: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  sensitiveCardData: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.object,
};

export default CardDetailsModal;
